module.exports = __webpack_public_path__ + "img/xz_certificate1.2f967473.png";